module.exports = "<div class=\"alloc-popup-wrapper\">\n\n  <lfwms-result-data-table [showSelectOption]=\"false\" \n[searchService]=\"lookupSearchService\">\n</lfwms-result-data-table>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-backend-status-popup/wave-backend-status-popup.component.html
// module id = ../../../../../src/app/shared/lookup/wave-backend-status-popup/wave-backend-status-popup.component.html
// module chunks = main